// extracted by mini-css-extract-plugin
export default {"recentProjects":"PreviousProjects_recentProjects__wjQ7V","dataRow":"PreviousProjects_dataRow__iZtZd","cell":"PreviousProjects_cell__KlTBV"};